import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scs" }
const _hoisted_2 = { class: "scs__card" }
const _hoisted_3 = { class: "scs__row" }
const _hoisted_4 = { class: "scs__row" }
const _hoisted_5 = { class: "scs__card" }
const _hoisted_6 = {
  class: "scs__modes",
  role: "radiogroup",
  "aria-label": "별첨 2 작성 방식"
}
const _hoisted_7 = { class: "sc__panel scs__doc" }
const _hoisted_8 = { class: "scs__foot" }

import ServiceContractAnnex2Doc from '@/components/contract/ServiceContractAnnex2Doc.vue'
import type { ServiceContractForm } from '@/composables/useServiceContractForm'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractSetup',
  props: {
    form: {}
  },
  emits: ["back", "continue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function onContinue() {
  const wroteAnnex2 = props.form.annex2Mode === 'text'
    ? props.form.annex2Text.trim().length > 0
    : Boolean(props.form.wageFee || props.form.acctFee || props.form.monthlyTotal.trim())
  if (wroteAnnex2) props.form.annexAgreed.a2 = true
  emit('continue')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("header", { class: "scs__hero" }, [
      _createElementVNode("p", { class: "scs__eyebrow" }, "HAMWOORI / NEW CONTRACT"),
      _createElementVNode("h1", { class: "scs__title" }, "새 계약서"),
      _createElementVNode("p", { class: "scs__lead" }, " 함우리 정보와 별첨 2를 먼저 정합니다. 여기서 적은 내용은 「계약서 작성」 이후 피계약자에게 그대로 보이고, 그 화면에서는 고치지 않습니다. ")
    ], -1)),
    _createElementVNode("form", {
      class: "scs__main",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("section", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "scs__h" }, "함우리 정보", -1)),
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "scs__hint" }, "계약서의 을 자리에 들어갑니다. 기본값을 그대로 두거나 이 계약에 맞게 고칩니다.", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("label", {
          class: "scs__label",
          for: "scs-b-name"
        }, "상호", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "scs-b-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.partyBLegalName) = $event)),
          class: "scs__input",
          type: "text"
        }, null, 512), [
          [_vModelText, __props.form.partyBLegalName]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              class: "scs__label",
              for: "scs-b-biz"
            }, "사업자등록번호", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scs-b-biz",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.partyBBizNumber) = $event)),
              class: "scs__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.partyBBizNumber]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              class: "scs__label",
              for: "scs-b-owner"
            }, "대표자", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scs-b-owner",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.partyBOwner) = $event)),
              class: "scs__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.partyBOwner]
            ])
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("label", {
          class: "scs__label",
          for: "scs-b-addr"
        }, "소재지", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "scs-b-addr",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.partyBAddress) = $event)),
          class: "scs__input",
          type: "text"
        }, null, 512), [
          [_vModelText, __props.form.partyBAddress]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              class: "scs__label",
              for: "scs-b-phone"
            }, "연락처", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scs-b-phone",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.partyBPhone) = $event)),
              class: "scs__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.partyBPhone]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "scs__label",
              for: "scs-b-org"
            }, "담당조직", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scs-b-org",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.form.partyBOrg) = $event)),
              class: "scs__input",
              type: "text"
            }, null, 512), [
              [_vModelText, __props.form.partyBOrg]
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "scs__h" }, "별첨 2", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "scs__hint" }, " 피계약자에게 보일 문서 모양 그대로 적습니다. ☑와 밑줄 칸을 누르면 그 자리에서 입력됩니다. 양식에 없는 계약이면 텍스트로 적습니다. ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["scs__mode", { 'is-on': __props.form.annex2Mode !== 'text' }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (__props.form.annex2Mode = 'form'))
          }, " 양식대로 작성 ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["scs__mode", { 'is-on': __props.form.annex2Mode === 'text' }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (__props.form.annex2Mode = 'text'))
          }, " 텍스트로 작성 ", 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "sc__topline" }, null, -1)),
          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "sc__doctype" }, "별첨 2", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("h2", null, "서비스 요금·청구 및 정산 합의서", -1)),
          _createVNode(ServiceContractAnnex2Doc, { form: __props.form }, null, 8, ["form"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "scs__btn scs__btn--ghost",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('back')))
        }, "목록"),
        _createElementVNode("button", {
          type: "submit",
          class: "scs__btn scs__btn--teal",
          onClick: onContinue
        }, "계약서 작성")
      ])
    ], 32)
  ]))
}
}

})